<template>
    <div class="case-detail">
      <div class="head-info">
        <h3>{{casedetail.title}}</h3>
        <h5>{{casedetail.createtime}}发布</h5>
       <img :src="casedetail.qr_image" alt="">
       <p v-if="casedetail.service_brand">服务品牌<span>{{casedetail.service_brand}}</span></p>
       <p v-if="casedetail.service_items">服务项目<span>{{casedetail.service_items}}</span></p>
       <p v-if="casedetail.industry_idindustry_id">服务分类<span>{{casedetail.industry_idindustry_id}}</span></p>
       <p v-if="casedetail.service_cycle">服务周期<span>{{casedetail.service_cycle}}</span></p>

      </div>
        <div class="title">
            <canvas id="title-canvas">
            </canvas>
            <h2>案例详情</h2>
        </div>
        <div class="success-swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide swiper-no-swiping">
                    <!--<img src="../../static/images/case_detail.png" alt="">-->
                    <div v-html="casedetail.content"></div>
                </div>
            </div>
        </div>
        <div class="end">-&nbsp;THE&nbsp;END&nbsp;-</div>
        <!--<div class="swiper-controller">
            <div class="success-swiper-prev"><i class="iconfont icon-jiantouzuo"></i>上一个</div>
            <span>|</span>
            <div class="success-swiper-next">下一个<i class="iconfont icon-icon_arrow_right"></i></div>
        </div>-->
    </div>
</template>

<script>
import Swiper from 'swiper'
export default {
    name: 'Title',
    props: {
        casedetail:Object
    },
    mounted () {
        this.canvasTitle()
        this.successSwiper()
    },
    methods: {
        successSwiper () {
            var swiper = new Swiper('.success-swiper-container',{
                navigation: {
                    nextEl: '.success-swiper-next',
                    prevEl: '.success-swiper-prev',
                },
                noSwiping : true,
            });
        },
        canvasTitle () {
            var canvas = document.getElementById('title-canvas')
            var ctx = canvas.getContext('2d')
            canvas.width = document.body.clientWidth
            canvas.height = document.body.clientWidth * 0.2
            ctx.font = '800 1.6rem "微软雅黑"'
            ctx.textBaseline = "middle"
            ctx.textAlign = "center"
            ctx.fillStyle = "#f6f6f6"
            ctx.fillText("DETAILS",canvas.width * 0.5 , canvas.height * 0.52)
        },
        imgShow (str) {
            var reg = new RegExp(/(src=")([^"]*")/g)
            var arr = reg.exec(str)
            if(!arr){
                return str
            }
            else{
                return str.replace(reg,"$1https://guanwang.wsandos.com$2")
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';

.case-detail >>> .swiper-button-disabled {
  color: #999 !important;
}

.swiper-slide >>> img {
  width: 100%;
}

.head-info {
  position: relative;
  // top: -3rem;
  // left: calc(((100% - 7rem) / 2));
  width: 7rem;
  // height: 6rem;
  padding: 0.45rem 0;
  background: #FFFFFF;
  box-shadow: 0px 3px 15px 0px rgba(111, 111, 111, 0.1);
  border-radius: 0.1rem;
  margin: -3rem auto 0.8rem;

  >h3 {
    font-size: 0.42rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 0.6rem;
  }

  >h5 {
    font-size: 0.22rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 0.39rem;
    opacity: 0.6;
    margin: 0.23rem 0 0.25rem;
  }

  >img {
    width: 2rem;
    height: 2rem;
    // border-radius: 50%;
  }

  >p {
    font-size: 0.22rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 0.39rem;
    margin-top: 0.2rem;

    >span {
      margin-left: 0.51rem;
    }
  }
}

.case-detail {
  padding: 10% 0;
  text-align: center;
  font-size: 0.3rem;

  .title {
    position: relative;

    #title-canvas {
      vertical-align: middle;
    }

    h2 {
      position: absolute;
      font-size: 0.4rem;
      top: 50%;
      left: 50%;
      margin: -0.5em 0 0 -2em;
      font-weight: 800;
      color: #333;
      letter-spacing: 1px;

      &:after {
        content: '';
        position: absolute;
        margin-left: -25%;
        display: block;
        border-bottom: 1px solid $black;
        width: 50%;
        bottom: -0.4rem;
        left: 50%;
      }
    }
  }

  .success-swiper-container {
    overflow: hidden;
    width: 100%;

    img {
      width: 100%;
    }
  }

  .end {
    margin-top: 2em;
    padding-bottom: 1em;
    color: $black;
    border-bottom: 1px solid #eee;
  }

  .swiper-controller {
    display: inline-block;
    background: $black;
    color: #fff;
    margin: 2em 0 4em;

    >div {
      display: inline-block;
      padding: 0 1em;
      line-height: 3em;

      i {
        margin: 0 0.3em;
        font-size: 0.26rem;
      }
    }

    span {
      color: #666;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/CaseDetail.vue